module.exports = __webpack_public_path__ + "img/berserk.67f6a91e.jpg";